import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { Layout } from "@/components/Layout";
import { ProtectedRoute, AdminRoute } from "@/components/ProtectedRoute";
import { Toaster } from "sonner";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import ProductDetail from "@/pages/ProductDetail";
import BrandPage from "@/pages/BrandPage";
import TryOn from "@/pages/TryOn";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Account from "@/pages/Account";
import SellToLookers from "@/pages/SellToLookers";
import TradeIn from "@/pages/TradeIn";
import ConditionGuide from "@/pages/ConditionGuide";
import HowItWorks from "@/pages/HowItWorks";
import Sustainability from "@/pages/Sustainability";
import AboutStory from "@/pages/AboutStory";
import OfferPage from "@/pages/OfferPage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsConditions from "@/pages/TermsConditions";
import ShippingReturns from "@/pages/ShippingReturns";
import Returns from "@/pages/Returns";
import FitGuide from "@/pages/FitGuide";
import ShareYourLook from "@/pages/ShareYourLook";
import Authenticity from "@/pages/Authenticity";
import FAQs from "@/pages/FAQs";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminAttention from "@/pages/admin/AdminAttention";
import AdminInventory from "@/pages/admin/AdminInventory";
import ProductWizard from "@/pages/admin/ProductWizard";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminSellSubmissions from "@/pages/admin/AdminSellSubmissions";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminReviews from "@/pages/admin/AdminReviews";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Toaster position="top-center" />
            <Routes>
              <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
                <Route index element={<AdminDashboard />} />
                <Route path="attention" element={<AdminAttention />} />
                <Route path="inventory" element={<AdminInventory />} />
                <Route path="inventory/new" element={<ProductWizard />} />
                <Route path="orders" element={<AdminOrders />} />
                <Route path="sell-to-lookers" element={<AdminSellSubmissions />} />
                <Route path="customers" element={<AdminCustomers />} />
                <Route path="reviews" element={<AdminReviews />} />
                <Route path="settings" element={<AdminSettings />} />
              </Route>

              <Route path="*" element={
                <Layout>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/shop" element={<Shop />} />
                    <Route path="/product/:slug" element={<ProductDetail />} />
                    <Route path="/brands" element={<BrandPage />} />
                    <Route path="/brands/:slug" element={<BrandPage />} />
                    <Route path="/try-on" element={<TryOn />} />
                    <Route path="/try-on/:productId" element={<TryOn />} />
                    <Route path="/cart" element={<Cart />} />
                    <Route path="/checkout" element={<Checkout />} />
                    <Route path="/payment/success" element={<PaymentSuccess />} />
                    <Route path="/payment/cancel" element={<PaymentCancel />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/account/*" element={<ProtectedRoute><Account /></ProtectedRoute>} />
                    <Route path="/sell" element={<SellToLookers />} />
                    <Route path="/trade-in" element={<TradeIn />} />
                    <Route path="/condition-guide" element={<ConditionGuide />} />
                    <Route path="/fit-guide" element={<FitGuide />} />
                    <Route path="/share-your-look" element={<ShareYourLook />} />
                    <Route path="/how-it-works" element={<HowItWorks />} />
                    <Route path="/sustainability" element={<Sustainability />} />
                    <Route path="/about" element={<AboutStory />} />
                    <Route path="/offer/:submissionId" element={<ProtectedRoute><OfferPage /></ProtectedRoute>} />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/terms-conditions" element={<TermsConditions />} />
                    <Route path="/shipping-returns" element={<ShippingReturns />} />
                    <Route path="/returns" element={<Returns />} />
                    <Route path="/authenticity" element={<Authenticity />} />
                    <Route path="/faqs" element={<FAQs />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </Layout>
              } />
            </Routes>
          </BrowserRouter>
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
